import React, { useState } from 'react'
import pageLogo from "./../../Images/pageicon.png" ; 
import {  NavLink, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { deletePageAccessTokenAPI } from '../../RTK/Slice/PageSlice';
import { getToken } from '../../RTK/Slice/Auth/AuthSlice';

const PageCard = ({title,tokenId , accessToken,pageId}) => {

  // For Handle Dispatch Aciton
  const dispatch = useDispatch() ; 

  // For Animation Of Trash Icon
  const [trashMove ,setTrashMove] = useState(false) ; 

  // For Get Token
  const token = useSelector(getToken) ; 

  const {t , i18n} = useTranslation() ; 

  // For Delete Access Token
  const deleteAccessTokenHandler = ()=>{
    dispatch(deletePageAccessTokenAPI({token , tokenId}))
  }


  return (
    <div  o className='page-card'>
        <NavLink  to={`${pageId}/${accessToken}`} style={{textDecoration : "none"}} className='left'>
          <div className='page-logo'>
              <img  src={pageLogo} alt='page-logo' />
          </div>
          <div className='page-titles'>
                <h3>{title}</h3>              
              <p className='page-type'>{accessToken? accessToken.length > 30 ? `${accessToken.slice(0,30)}...` : accessToken :""} </p>
          </div>
        </NavLink>

        {/*<div onClick={deleteAccessTokenHandler} className={` ${i18n.language === 'ar' ? 'rr' : "right"} `} onMouseOver={()=>setTrashMove(true)} onMouseLeave={()=>setTrashMove(false)}>
          <FontAwesomeIcon icon={faTrash} bounce={trashMove} />
        </div>*/}
        
    </div>
  )
}

export default PageCard
